module.exports = __webpack_public_path__ + "static/media/MTL_ASC_MED3.9399904a.png";